import { URL } from "../constants";
import { apiSlice } from "./apiSlice";

export const quoteApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getInstantQuoteConfig: builder.query({
      /**
       * 获取即时报价配置项。
       * @returns {{url: string, method: string}}
       */
      query: () => ({
        url: `${URL}/quotes/config`,
        method: "GET",
      }),
      providesTags: ["Quote"],
    }),

    calculateInstantQuote: builder.mutation({
      /**
       * 计算即时报价。
       * @param {Object} payload 报价参数
       * @returns {{url: string, method: string, body: Object}}
       */
      query: (payload) => ({
        url: `${URL}/quotes/calculate`,
        method: "POST",
        body: payload,
      }),
    }),

    createQuote: builder.mutation({
      /**
       * 创建报价单。
       * @param {FormData} formData 报价表单数据
       * @returns {{url: string, method: string, body: FormData}}
       */
      query: (formData) => ({
        url: `${URL}/quotes`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Quote"],
    }),

    updateQuote: builder.mutation({
      /**
       * 更新报价单。
       * @param {{id: string, formData: FormData}} params 更新参数
       * @returns {{url: string, method: string, body: FormData}}
       */
      query: ({ id, formData }) => ({
        url: `${URL}/quotes/${id}`,
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["Quote"],
    }),

    getQuoteDetails: builder.query({
      /**
       * 获取报价单详情。
       * @param {string} id 报价单 ID
       * @returns {{url: string, method: string}}
       */
      query: (id) => ({
        url: `${URL}/quotes/${id}`,
        method: "GET",
      }),
      providesTags: ["Quote"],
    }),

    submitQuote: builder.mutation({
      /**
       * 提交报价单到人工跟进流程。
       * @param {{id: string, message: string}} payload 提交参数
       * @returns {{url: string, method: string, body: Object}}
       */
      query: ({ id, message }) => ({
        url: `${URL}/quotes/${id}/submit`,
        method: "POST",
        body: { message },
      }),
      invalidatesTags: ["Quote"],
    }),

    addQuoteToCart: builder.mutation({
      /**
       * 将报价单转换为购物车项。
       * @param {string} id 报价单 ID
       * @returns {{url: string, method: string}}
       */
      query: (id) => ({
        url: `${URL}/quotes/${id}/add-to-cart`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetInstantQuoteConfigQuery,
  useCalculateInstantQuoteMutation,
  useCreateQuoteMutation,
  useUpdateQuoteMutation,
  useGetQuoteDetailsQuery,
  useSubmitQuoteMutation,
  useAddQuoteToCartMutation,
} = quoteApi;
